/** Question slide variant — letter-by-letter reveal of the question +
 *  soft "tap to continue" prompt. */
import type { VariantProps } from '../registry';

export function QuestionVariant({ slide }: VariantProps) {
  const text = slide.contentText || 'Will you?';
  return (
    <div className="preview-slide-content relative flex flex-col items-center gap-6">
      <h2 className="preview-slide-question">
        {text.split('').map((ch, i) => (
          <span
            key={i}
            className="preview-question-char"
            style={{ animationDelay: `${i * 0.07}s` }}
          >
            {ch}
          </span>
        ))}
      </h2>
      <p className="preview-question-prompt text-[0.7rem] uppercase tracking-[0.2em] text-white/45">
        tap to continue
      </p>
    </div>
  );
}
